import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { CalendarClock, MapPin } from "lucide-react";

/**
 * Compact list of the client's upcoming booked sessions — regardless of
 * whether they came from an in-person subscription or the coach booked
 * them directly on the shared calendar (staff-book). Hidden entirely when
 * there's nothing on the books, so it doesn't clutter clients who aren't
 * training in-person yet.
 */
const fmt = (iso) =>
  new Date(iso).toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

export default function MySessionsCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let mounted = true;
    api
      .get("/sessions/mine")
      .then((r) => mounted && setData(r.data || null))
      .catch(() => mounted && setData(null));
    return () => {
      mounted = false;
    };
  }, []);

  if (!data || !data.upcoming || data.upcoming.length === 0) return null;

  return (
    <div className="obs-card mb-6" data-testid="my-sessions-card">
      <div className="flex items-center gap-3 mb-3">
        <CalendarClock className="h-5 w-5 text-blaze" />
        <div className="flex-1 min-w-0">
          <div className="overline">Upcoming with your coach</div>
          <h3 className="font-heading text-2xl uppercase truncate">
            {data.coach_name ? `Sessions with ${data.coach_name}` : "Booked sessions"}
          </h3>
        </div>
        <span className="text-[10px] uppercase tracking-widest text-zinc-500">
          {data.upcoming.length} scheduled
        </span>
      </div>
      <div className="space-y-2">
        {data.upcoming.slice(0, 6).map((s) => (
          <div
            key={s.id}
            data-testid={`my-session-${s.id}`}
            className="flex items-center gap-3 p-2 border border-obsidian-600 rounded-sm"
          >
            <MapPin className="h-4 w-4 text-blaze shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="text-sm text-zinc-100">{fmt(s.scheduled_at)}</div>
              <div className="text-[10px] text-zinc-500 uppercase tracking-widest">
                {s.duration_min || 60} min{s.note ? ` · ${s.note}` : ""}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
